export const FILTER_SETS_LIST_REQUESTED = 'FilterSets_GetListRequested'
export const FILTER_SETS_LIST_SUCCESS = 'FilterSets_GetListSuccess'
export const FILTER_SETS_LIST_FAILURE = 'FilterSets_GetListFailure'

export const FILTER_SET_DETAILS_REQUESTED = 'FilterSet_GetDetailsRequested'
export const FILTER_SET_DETAILS_SUCCESS = 'FilterSet_GetDetailsSuccess'
export const FILTER_SET_DETAILS_FAILURE = 'FilterSet_GetDetailsFailure'

export const FILTER_SET_SAVE_REQUESTED = 'FilterSet_SaveRequested'
export const FILTER_SET_SAVE_SUCCESS = 'FilterSet_SaveSuccess'
export const FILTER_SET_SAVE_FAILURE = 'FilterSet_SaveFailure'

export const FILTER_SET_CREATE_REQUESTED = 'FilterSet_CreateRequested'
export const FILTER_SET_CREATE_SUCCESS = 'FilterSet_CreateSuccess'
export const FILTER_SET_CREATE_FAILURE = 'FilterSet_CreateFailure'

export const FILTER_SET_DELETE_REQUESTED = 'FilterSet_DeleteRequested'
export const FILTER_SET_DELETE_SUCCESS = 'FilterSet_DeleteSuccess'
export const FILTER_SET_DELETE_FAILURE = 'FilterSet_DeleteFailure'

export const CHANGE_FILTER_SET = 'FilterSet_Changed'

export const FILTER_SET_RESET = 'FilterSet_Reset'

export const OPEN_FILTER_SETS = 'FilterSet_OpenLoad'
export const CLOSE_FILTER_SETS = 'FilterSet_CloseLoad'

export const OPEN_SAVE = 'FilterSet_OpenSave'
export const CLOSE_SAVE = 'FilterSet_CloseSave'

export const OPEN_MANAGE = 'FilterSet_OpenManage'
export const CLOSE_MANAGE = 'FilterSet_CloseManage'

export const SAVE_TYPE = {
  NEW: 'NEW',
  OVERWRITE: 'OVERWRITE',
} as const
